import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  content: "内容",
  fontFamily: "字体",
  fontSize: "字体大小",
  fontWeight: "字重",
  fontColor: "文字颜色",
  bgColorType: "背景颜色类型",
  bgColor: "背景颜色",
  bgStartColor: "背景渐变色开始色值",
  bgEndColor: "背景渐变色结束色值",
  borderColor: "边框颜色",
  bgColorlinearGradientAngle: "背景渐变角度",
  decimal: "保留小数点位数",
  showThousandSeparator: "显示千位分隔符",
  showSeparatorBackground: "显示分隔符背景",
  showPrefix: "显示前缀",
  prefixContent: "前缀内容",
  prefixFontFamily: "前缀字体",
  prefixFontSize: "前缀字体大小",
  prefixFontWeight: "前缀字重",
  prefixFontColor: "前缀字体颜色",
  prefixFontMarginBottom: "前缀下边距",
  prefixFontMarginRight: "前缀右边距",
  suffixFontMarginLeft: "后缀左边距",
  showSuffix: "显示后缀",
  suffixContent: "后缀内容",
  suffixFontFamily: "后缀字体",
  suffixFontSize: "后缀字体大小",
  suffixFontWeight: "后缀字重",
  suffixFontColor: "后缀字体颜色",
  suffixFontMarginBottom: "后缀下边距",
  marginRight: "数字间隔",
  isFixed: "数字展示方式", // false:自适应  true:固定
  digitRollTextAlign: "数字对齐方式",
  animateInterval: "动画间隔时间",
  animateDuration: "动画持续时间",
  updateTimer: "数据源轮询时间",
  restDataUrl: "外接数据源地址"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
